export default __webpack_public_path__ + "static/media/success-icon.ecf1967f.svg";